<template>
  <div>
    <el-dialog v-bind="$attrs" :title="title" v-on="$listeners" ref="dialog" :show-close="false" :close-on-click-modal="false" class="dialog-dark dialog-center peopleHeader" width="400px">
      <div class="people">
        <!-- <p class="font-c99 fontColor">{{ title || "" }}</p> -->
        <p class="peopleNum">{{ $t("signIn.请在以下时间内完成") }}</p>
        <div class="timerOut">
          <div class="timeText">{{ duration }}<i>s</i></div>
        </div>
        <div class="sign-end">
          <el-button class="sign-btn" type="primary" size="mini" @click="signIn">{{ $t("signIn.签到") }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { rollcall } from "@/api/liveRequest/rollcalls";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import { mapGetters } from "vuex";
export default {
  props: {
    duration: Number,
    title: String,
  },
  data() {
    return {
      sign: undefined,
    };
  },
  computed: {
    ...mapGetters(["confId"]),
  },
  created() {
    pushRoomMessageFunc(({ cmd, requestData }) => {
      const fn = this[`message_${cmd}`];
      typeof fn === "function" && fn(requestData);
    });
  },
  methods: {
    message_7107(body) {
      switch (body.event) {
        case "rollcall/state":
          this.sign = body;
          break;
      }
    },
    message_7127(body) {
      switch (body.event) {
        case "rollcall/state":
          this.sign = body;
          break;
      }
    },

    async signIn() {
      const { code } = await rollcall.answer({ confId: this.confId, id: this.sign.id });
      if (code == 200) {
        this.$message.success(`${this.$t("signIn.签到成功")}`);
        this.$emit("signInSuccess");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.people {
  text-align: center;
  position: relative;
}
.font-c99 {
  margin-bottom: 23px;
  font-size: 12px;
}
.peopleHeader ::v-deep {
  .el-dialog__body {
    padding-top: 14px;
  }
}
.timerOut {
  width: 86px;
  height: 86px;
  border-radius: 43px;
  background: #abcfff;
  text-align: center;
  margin: 20px auto 18px;
}
.timerOut .timeText {
  font-size: 42px;
  color: #3986ee;
  line-height: 86px;
}
.timerOut .timeText i {
  font-style: normal;
  font-size: 28px;
  line-height: 1;
}
.sign-end {
  text-align: center;
  padding-top: 5px;
  &-btn {
    background: linear-gradient(311deg, #ff5f46 0%, #ff4d5b 100%);
    border-radius: 6px;
    border: none;
  }
}
</style>
